import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { PROVIDER_REGISTRATION_TITLE_PROPS, SERVICE_OPTIONS } from "~/utils/providerRegistrationHelpers";

const Services = () => {
  const { control } = useFormContext();

  return (
    <Stack direction="column" spacing={2}>
      <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
        Which of the following services are you interesting in providing?
      </Typography>
      <Controller
        control={control}
        defaultValue={[]}
        name="services"
        render={({ field }) => (
          <>
            {SERVICE_OPTIONS.map(([serviceValue, serviceLabel]) => (
              <FormControlLabel
                key={serviceValue}
                control={
                  <Checkbox
                    checked={field.value?.includes(serviceValue) || false}
                    onChange={(e) => {
                      const newValue = e.target.checked
                        ? [...(field.value || []), serviceValue]
                        : field.value?.filter((prevService: string) => prevService !== serviceValue);
                      field.onChange(newValue);
                    }}
                  />
                }
                label={serviceLabel}
              />
            ))}
          </>
        )}
      />
    </Stack>
  );
};

export default Services;
